var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      [
        _vm.productsLoaded == false
          ? [
              _c("p", { staticClass: "m-0" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.loading")) + "\n      "
                )
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.productsLoaded == true
          ? [
              _c(
                "section",
                [
                  _c("section-title", {
                    attrs: { title: _vm.$t("message.item") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(
                          "vs-radio",
                          {
                            staticStyle: { float: "left", padding: "0" },
                            attrs: { color: "#A3CA76", vsValue: "bom" },
                            on: { change: _vm.handleFormTypeChange },
                            model: {
                              value: _vm.formType,
                              callback: function($$v) {
                                _vm.formType = $$v
                              },
                              expression: "formType"
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("apps.inventory.message.selectbom")
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(
                          "vs-radio",
                          {
                            staticStyle: { float: "left", padding: "0" },
                            attrs: { color: "#A3CA76", vsValue: "custom" },
                            on: { change: _vm.handleFormTypeChange },
                            model: {
                              value: _vm.formType,
                              callback: function($$v) {
                                _vm.formType = $$v
                              },
                              expression: "formType"
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("apps.inventory.message.selectcustom")
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.formType == "bom"
                    ? _c("div", { staticClass: "row mb-3" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedBomId,
                                  expression: "selectedBomId"
                                }
                              ],
                              staticClass: "custom-select",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedBomId = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  _vm.handleSelectBom
                                ]
                              }
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("placeholder.select")) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.bomOptions, function(item, index) {
                                return _c(
                                  "option",
                                  {
                                    key: index,
                                    domProps: { value: item.value }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.text) +
                                        "\n              "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showForm
                    ? _c(
                        "div",
                        { staticClass: "row m-0" },
                        _vm._l(_vm.items, function(item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "col-12 box mb-3" },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    class: _vm.disabledActions
                                      ? "col-12"
                                      : "col-lg-11"
                                  },
                                  [
                                    _c("div", { staticClass: "form-row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-12 mb-2" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item.reason,
                                                  expression: "item.reason"
                                                }
                                              ],
                                              staticClass:
                                                "form-control form-control-sm custom-select",
                                              attrs: { disabled: true },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    item,
                                                    "reason",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "",
                                                    disabled: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "placeholder.selectreason"
                                                        )
                                                        .toLowerCase()
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "manual recount"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "apps.inventory.message.recount"
                                                        )
                                                        .toLowerCase()
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "manual received"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "apps.inventory.message.received"
                                                        )
                                                        .toLowerCase()
                                                    ) + " +"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "manual issue"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "apps.inventory.message.manualissue"
                                                        )
                                                        .toLowerCase()
                                                    ) + " -"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "manual return"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "apps.inventory.message.return"
                                                        )
                                                        .toLowerCase()
                                                    ) + " +"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "manual loss"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "apps.inventory.message.loss"
                                                        )
                                                        .toLowerCase()
                                                    ) + " -"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "manual damage"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "apps.inventory.message.damage"
                                                        )
                                                        .toLowerCase()
                                                    ) + " -"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "manual consumed production"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "apps.inventory.message.consumedproduction"
                                                        )
                                                        .toLowerCase()
                                                    ) + " -"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "manual received production"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "apps.inventory.message.receivedproduction"
                                                        )
                                                        .toLowerCase()
                                                    ) + " +"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "form-row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-9 mb-mobile-2" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "wrapper-selectize",
                                              class: item.validateSkuId
                                            },
                                            [
                                              _c("vue-bootstrap-autocomplete", {
                                                attrs: {
                                                  data: _vm.optionSkus.filter(
                                                    function(opt) {
                                                      return (
                                                        _vm.selectedSkuIds.indexOf(
                                                          opt.value
                                                        ) === -1
                                                      )
                                                    }
                                                  ),
                                                  serializer: function(item) {
                                                    return (
                                                      item.text +
                                                      " " +
                                                      (item.sku_code || "")
                                                    )
                                                  },
                                                  minMatchingChars: 1,
                                                  maxMatches: 10,
                                                  placeholder: _vm.$t(
                                                    "placeholder.selectitem"
                                                  ),
                                                  loading: item.loading,
                                                  disabled: _vm.disabledActions,
                                                  showCreate: false,
                                                  noResultsInfo: item.loaded
                                                    ? _vm.$t(
                                                        "message.notfounddata"
                                                      )
                                                    : null
                                                },
                                                on: {
                                                  input: function($event) {
                                                    _vm.items[
                                                      index
                                                    ].loading = true
                                                    _vm.lookupProducts(
                                                      index,
                                                      $event
                                                    )
                                                  },
                                                  hit: function($event) {
                                                    return _vm.handleSelectProduct(
                                                      index,
                                                      $event
                                                    )
                                                  },
                                                  blur: function($event) {
                                                    return _vm.handleBlurProduct(
                                                      index,
                                                      $event
                                                    )
                                                  },
                                                  inputBlur: function($event) {
                                                    return _vm.handleInputBlurProduct(
                                                      index,
                                                      $event
                                                    )
                                                  },
                                                  keydown: function($event) {
                                                    return _vm.handleKeydownProduct(
                                                      index,
                                                      $event
                                                    )
                                                  },
                                                  keyup: function($event) {
                                                    return _vm.handleKeyupProduct(
                                                      index,
                                                      $event
                                                    )
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "suggestion",
                                                      fn: function(ref) {
                                                        var data = ref.data
                                                        var htmlText =
                                                          ref.htmlText
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center"
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticStyle: {
                                                                  width: "40px",
                                                                  height:
                                                                    "40px",
                                                                  "border-radius":
                                                                    "0.25rem"
                                                                },
                                                                attrs: {
                                                                  src: _vm.productImage(
                                                                    data.value
                                                                  )
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex flex-column"
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "ml-4",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        data.text
                                                                      )
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "ml-4",
                                                                    staticStyle: {
                                                                      "font-size":
                                                                        "11px"
                                                                    },
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        data.sku_code
                                                                      )
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value: item.queryProductName,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "queryProductName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.queryProductName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-3 mb-mobile-2" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-prepend"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "input-group-text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.quantity"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: item.qty,
                                                    expression: "item.qty"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control text-right number-only text-select-all",
                                                attrs: {
                                                  disabled:
                                                    item.sku_id.length == 0,
                                                  type: "text"
                                                },
                                                domProps: { value: item.qty },
                                                on: {
                                                  keypress: _vm.numberOnly,
                                                  keyup: function($event) {
                                                    item.qty = _vm.setToValidNumber(
                                                      item.qty
                                                    )
                                                  },
                                                  blur: function($event) {
                                                    item.qty = _vm.setToCustomDigitsNumber(
                                                      item.qty
                                                    )
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      item,
                                                      "qty",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    item.reason.length > 0 &&
                                    item.sku_id.length > 0
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-row mt-0 mt-lg-2"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-12" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-group"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group-prepend"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "input-group-text",
                                                              staticStyle: {
                                                                "border-radius":
                                                                  "0.25em 0 0 0"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.currentBinLocationName
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        staticClass:
                                                          "form-control text-right",
                                                        staticStyle: {
                                                          "border-left": "0",
                                                          "border-radius":
                                                            "0 0.25em 0 0"
                                                        },
                                                        attrs: {
                                                          disabled: true,
                                                          type: "text"
                                                        },
                                                        domProps: {
                                                          value: _vm.getCurrentStockByBinId(
                                                            item.sku_id,
                                                            _vm.whId,
                                                            _vm.selectedBinLocationId
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-group"
                                                    },
                                                    [
                                                      _vm._m(0, true),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        staticClass:
                                                          "form-control text-right",
                                                        class: _vm.getFontColor(
                                                          _vm.getCurrentStockByBinId(
                                                            item.sku_id,
                                                            _vm.whId,
                                                            _vm.selectedBinLocationId
                                                          ),
                                                          _vm.getNewCalcStock(
                                                            item.reason,
                                                            _vm.getCurrentStockByBinId(
                                                              item.sku_id,
                                                              _vm.whId,
                                                              _vm.selectedBinLocationId
                                                            ),
                                                            item.qty
                                                          )
                                                        ),
                                                        staticStyle: {
                                                          "border-left": "0px",
                                                          "border-top": "0",
                                                          "border-radius":
                                                            "0 0 0.25em 0"
                                                        },
                                                        attrs: {
                                                          disabled: true,
                                                          type: "text"
                                                        },
                                                        domProps: {
                                                          value: _vm.getNewCalcStock(
                                                            item.reason,
                                                            _vm.getCurrentStockByBinId(
                                                              item.sku_id,
                                                              _vm.whId,
                                                              _vm.selectedBinLocationId
                                                            ),
                                                            item.qty
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                !_vm.disabledActions
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-1 pl-lg-0 mt-2 mt-lg-0"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-block h-100",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                return _vm.del(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-trash-alt"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.disabledActions && _vm.showForm
                ? _c("section", [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        on: {
                          click: function($event) {
                            return _vm.add()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.addproduct")))]
                    )
                  ])
                : _vm._e()
            ]
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass: "input-group-text",
          staticStyle: { "border-top": "0px", "border-radius": "0 0 0 0.25em" }
        },
        [_c("i", { staticClass: "fas fa-sync-alt" })]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2aa33f2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa33f2b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/stockcontrol/include/ModalIssueReturn.vue
// module id = null
// module chunks = 